import { render, staticRenderFns } from "./postInfo.vue?vue&type=template&id=58ef60c8&scoped=true"
import script from "./postInfo.vue?vue&type=script&lang=js"
export * from "./postInfo.vue?vue&type=script&lang=js"
import style0 from "./postInfo.vue?vue&type=style&index=0&id=58ef60c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ef60c8",
  null
  
)

export default component.exports